import React, { useEffect, useState } from 'react';
import { Button, OutlinedInput } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { notif } from '../../utils/util';
import { FaDownload, FaSave, FaUpload } from 'react-icons/fa';
import { timeConverter } from '../../../utils/util';
import {
  downloadInventory,
  getRetailers,
  getVendorInventory,
  getVendors,
  propagateInventory,
} from '../../../server/server';
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridEventListener,
} from '@mui/x-data-grid';
import SimpleSpin from '../../utils/SimpleSpin';
import { LoadingButton } from '@mui/lab';
function ExportInventory() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [rowCountState, setRowCountState] = useState(6);
  const [isLoading, setIsLoading] = useState(true);
  const [updateIsLoading, setUpdateIsLoading] = useState(false);
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);
  type Retailer = {
    [key: string]: any;
    id?: string;
    name?: string;
  };
  type Vendor = {
    [key: string]: any;
    id?: string;
    name?: string;
    date?: string;
  };

  const [retailers, setRetailers] = useState<Retailer[]>([]);
  const [currentRetailer, setCurrentRetailer] = useState<any>();
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [vendorLoader, setVendorLoader] = useState(true);
  const [currentVendor, setCurrentVendor] = useState<Vendor>();
  const loadVendors = async () => {
    const respR = await getRetailers();
    if (respR.status === 200) {
      setRetailers(respR?.data);
      setCurrentRetailer(respR.data[0]);
      const resp = await getVendors(respR.data[0].id ?? '');

      if (resp?.status === 200 && respR.status === 200) {
        setVendorLoader(false);
        setVendors(resp?.data);
      }
    }
  };
  const loadVendorInventory = async (
    vendorId: any = currentVendor?.id,
    offset: any = 1
  ) => {
    const resp = await getVendorInventory(vendorId, pageSize, offset);

    if (resp?.status === 200) {
      setIsLoading(false);
      setCsvData(resp?.data?.products);
      setRowCountState(resp?.data?.total);
    }
  };

  const handleChange = (e: SelectChangeEvent) => {
    const vendor = vendors.find((r: Vendor) => r?.name === e.target.value);
    setCurrentVendor(vendor as any);
    loadVendorInventory(vendor?.id);
  };
  const updateInventory = async () => {
    if (currentVendor?.id && currentRetailer?.id) {
      setUpdateIsLoading(true);
      const resp = await propagateInventory(
        currentVendor?.id,
        currentVendor?.supplierId,
        currentVendor?.name
      );
      if (resp?.status === 201) {
        setUpdateIsLoading(false);
        notif('Inventory successfully updated', 'success');
        loadVendors();
      } else {
        setUpdateIsLoading(false);
        notif('Inventory not updated', 'error');
      }
    } else {
      notif('Please select vendor and retailer', 'warning');
    }
  };
  useEffect(() => {
    loadVendors();
  }, []);
  const setPageAndCall = (page: any) => {
    setPage(page);
    loadVendorInventory(currentVendor?.id, page * pageSize);
  };
  const columns: GridColDef[] = [
    { field: 'sku', headerName: 'SKU', width: 280 },
    { field: 'quantity', headerName: 'Quantity', width: 200 },
  ];
  const exportFile = async () => {
    if (currentVendor?.id && currentRetailer?.id) {
      setDownloadIsLoading(true);
      const resp = await downloadInventory(
        currentVendor?.id,
        currentVendor?.supplierId
      );
      if (resp.status === 200) {
        setDownloadIsLoading(false);
        notif('Inventory successfully downloaded', 'success');
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${currentRetailer.name}-${currentVendor.name}-${new Date()
            .toLocaleString('en-US', {
              timeZone: 'America/New_York',
            })
            .replaceAll(':', '-')}.csv`
        );
        document.body.appendChild(link);
        link.click();
      } else {
        setDownloadIsLoading(false);
        notif('Inventory not downloaded', 'error');
      }
    } else {
      notif('Please select vendor and retailer', 'warning');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-gray-200 text-4xl font-semibold">Export Inventory</h1>
      <div className="grid grid-cols-2 gap-10 w-fit">
        <div className="rounded-lg border border-[#81848f3d] w-[600px]  mt-8  p-3 flex justify-between">
          <div className="flex flex-col">
            <p className="text-gray-400 ml-4 w-full">
              Export current inventory
            </p>
            {vendorLoader ? (
              <SimpleSpin />
            ) : (
              <div>
                <FormControl variant="filled" sx={{ m: 1, minWidth: 160 }}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    sx={{ color: 'white' }}
                  >
                    Retailer
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    value={currentRetailer?.name}
                    className="capitalize"
                    sx={{
                      color: 'white',

                      '.MuiFilledInput-input': {
                        borderColor: 'white',
                        backgroundColor: '#0a1929',
                      },
                      '&:hover .MuiFilledInput-input': {
                        borderColor: 'white',
                      },
                      '.MuiSvgIcon-root ': {
                        fill: 'white !important',
                      },
                    }}
                  >
                    {retailers?.map((retailer: Retailer) => {
                      return (
                        <MenuItem
                          value={retailer?.name}
                          className="capitalize"
                          key={retailer?.id}
                        >
                          {retailer?.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl variant="filled" sx={{ m: 1, minWidth: 160 }}>
                  <InputLabel
                    id="demo-multiple-name-label"
                    sx={{ color: 'white' }}
                  >
                    Select Vendors
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-simple-select-filled"
                    value={currentVendor?.name}
                    className="capitalize"
                    onChange={handleChange}
                    sx={{
                      color: 'white',

                      '.MuiFilledInput-input': {
                        borderColor: 'white',
                        backgroundColor: '#0a1929',
                      },
                      '&:hover .MuiFilledInput-input': {
                        borderColor: 'white',
                      },
                      '.MuiSvgIcon-root ': {
                        fill: 'white !important',
                      },
                    }}
                  >
                    {vendors?.map((vendor: Vendor) => {
                      return (
                        <MenuItem
                          value={vendor?.name}
                          className="capitalize"
                          key={vendor?.id}
                        >
                          {vendor?.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            )}
          </div>
          <div className="flex flex-col justify-between">
            <p className="text-gray-100 mb-6 w-full text-right">
              {currentVendor?.id && (
                <div className="flex flex-col gap-2">
                  <span>
                    Last uploaded at{' '}
                    {new Date(currentVendor?.imported as string).toLocaleString(
                      'en-US',
                      {
                        timeZone: 'America/New_York',
                      }
                    )}
                  </span>
                  <span className="">
                    Last updated at{' '}
                    {new Date(currentVendor?.exported as string).toLocaleString(
                      'en-US',
                      {
                        timeZone: 'America/New_York',
                      }
                    )}
                  </span>
                </div>
              )}
            </p>

            <div className=" flex justify-end gap-2 items-end">
              <LoadingButton
                variant="contained"
                sx={{
                  backgroundColor: '',
                  color: 'white !important',
                  '& .MuiCircularProgress-svg': { color: 'white' },
                  '& .MuiLoadingButton-root': { color: 'white' },
                  '&  .MuiLoadingButton-loading': { color: 'white' },
                }}
                endIcon={<FaUpload />}
                loading={updateIsLoading}
                loadingPosition="end"
                onClick={updateInventory}
              >
                Update
              </LoadingButton>
              <LoadingButton
                variant="contained"
                sx={{
                  backgroundColor: 'green',
                  '&:hover': {
                    backgroundColor: '#024e02',
                  },
                }}
                endIcon={<FaDownload />}
                loadingPosition="end"
                loading={downloadIsLoading}
                onClick={exportFile}
              >
                Export
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      {currentVendor?.id && csvData && (
        <div className="mt-8 h-[425px]">
          <DataGrid
            rows={csvData}
            rowCount={rowCountState}
            loading={isLoading}
            pagination
            paginationMode="server"
            onPageChange={(newPage) => setPageAndCall(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            page={page}
            pageSize={pageSize}
            columns={columns}
            getRowId={(row) => row?.id}
            style={{ zIndex: 0 }}
            rowsPerPageOptions={[5]}
            sx={{
              color: 'white',
              '.MuiTablePagination-toolbar': { color: 'white' },
              '.MuiIconButton-root': { color: 'white' },
            }}
            disableSelectionOnClick
          />
        </div>
      )}
    </div>
  );
}

export default ExportInventory;
